import { GoogleIcon } from '@assets/icons/google-icon';
import { theme } from '@config/theme';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface GoogleButtonProps {
	disabled: boolean;
	handleClick: () => void;
}

export function GoogleButton({ disabled, handleClick }: GoogleButtonProps) {
	const { t } = useTranslation();

	return (
		<Button
			disabled={disabled}
			variant="outlined"
			classes={{
				root: 'w-[340px] !text-secondary !font-roboto !text-base !font-normal !leading-[150%] !tracking-[0.15px]',
			}}
			onClick={handleClick}
			sx={{
				textTransform: 'none',
				backgroundColor: 'white',
				borderColor: theme.palette.custom.lightGray,
			}}
			startIcon={<GoogleIcon />}
		>
			{t('continueWithGoogle')}
		</Button>
	);
}
